import { Button } from '@fairygodboss/ui';
import React from 'react';
// import Close from '../Images/Icons/Close';

export default class PopUp extends React.PureComponent {
    render() {
        const {
            minHeight,
            minWidth,
            maxHeight,
            maxWidth,
            clickOutside,
            absolutePosition,
            showPopUp,
            cancel,
            className,
            hideCloseButton,
            title,
            showLogo,
            logoType,
            children,
            close,
            buttonText,
            showOverlay,
        } = this.props;

        if (!showPopUp) return null;

        const positionClass = absolutePosition ? 'fixed' : 'relative';

        const style = {
            minHeight,
            minWidth,
            maxHeight,
            maxWidth,
        };

        const onClickOutside = () => {
            if (clickOutside) {
                cancel();
            }
        };

        return (
            <div className="component-Elements-PopUp">
                <style jsx>
                    {`
                        .component-Elements-PopUp div.overlay {
                            position: fixed;
                            width: 100%;
                            height: 100%;
                            display: block;
                            top: 0;
                            left: 0;
                            background-color: rgba(0, 0, 0, 0.6);
                            /*this sets the slightly see-through black*/
                            z-index: 100;
                            /*Make this less than the existing popup div*/
                        }

                        .component-Elements-PopUp .msg-panel .fgb-bubble-logo {
                            width: 120px;
                            height: 120px;
                            background-image: url(https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/icons/fgb-bubble-logo.webp);
                            background-position: 50%;
                            background-repeat: no-repeat;
                            background-size: contain;
                            margin: auto;
                        }
                        .component-Elements-PopUp .msg-panel .fgb-logo {
                            width: 100px;
                            height: 100px;
                            background-image: url(https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/fgb-logo-no-bubble_j3hjfz.webp);
                            background-position: 50%;
                            background-repeat: no-repeat;
                            background-size: contain;
                            margin: auto;
                        }
                        .component-Elements-PopUp .close {
                            width: 18px;
                            height: 18px;
                            background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1540910119/icons/close-white.webp");
                            background-position: center;
                            background-repeat: no-repeat;
                            position: absolute;
                            top: 15px;
                            right: 15px;
                        }
                        .component-Elements-PopUp .close span {
                            line-height: 1;
                        }
                        .component-Elements-PopUp .close:hover {
                            cursor: pointer;
                        }
                        .component-Elements-PopUp .button-div {
                            width: 150px;
                            margin: 15px auto;
                        }
                        .component-Elements-PopUp .fixed {
                            position: fixed;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -60%);
                            width: auto;
                            height: auto;
                            background-color: #fff;
                            z-index: 2000;
                        }
                        .component-Elements-PopUp .FGBPopUp {
                            max-height: 400px;
                            background-color: transparent;
                            background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1540932215/assets/sumome_login.jpg");
                            background-size: cover;
                            border-radius: 10px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            font-family: "Open Sans", sans-serif;
                            color: white;
                            box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px inset;
                        }
                        .component-Elements-PopUp .relative {
                            position: relative;
                        }
                        .component-Elements-PopUp .moderation-flag-style {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                        .component-Elements-PopUp svg {
                            width: 20px;
                            height: 20px;
                        }
                        .component-Elements-PopUp .fixed {
                            position: fixed !important;
                        }

                        @media (min-width: 768px) {
                            .component-Elements-PopUp .fixed {
                                position: fixed !important;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -60%);
                                width: auto;
                                height: auto;
                            }
                            .component-Elements-PopUp .allContent {
                                height: auto;
                            }
                            .component-Elements-PopUp .text-center {
                                height: 220px;
                                padding: 30px;
                            }
                            .component-Elements-PopUp .content {
                                grid-template-rows: auto;
                                height: auto;
                                width: 100%;
                            }
                        }
                        @media only screen and (max-width: 360px) {
                            .component-Elements-PopUp
                                .msg-panel
                                .fgb-bubble-logo {
                                width: 90px;
                                height: 90px;
                            }
                            .component-Elements-PopUp p {
                                font-size: 12px;
                            }
                        }
                        @media (max-width: 576px) {
                            .component-Elements-PopUp .FGBPopUp {
                                min-width: 320px;
                                max-height: 220px;
                            }
                        }
                        @media (min-width: 576px) and (max-width: 960px) {
                            .component-Elements-PopUp .FGBPopUp {
                                min-width: 500px;
                                min-height: 320px;
                                max-height: 360px;
                            }
                        }
                        @media (min-width: 600px) and (orientation: landscape) {
                            .component-Elements-PopUp .fixed {
                                position: fixed !important;
                                top: 75%;
                            }
                        }
                    `}
                </style>
                <div
                    style={style}
                    className={`text-center ${positionClass} whiteSpace ${className}`}
                    data-qa="popup"
                >
                    {cancel && !hideCloseButton && (
                        <div className="close">
                            <Button
                                onPress={cancel}
                                width="18px"
                                height="18px"
                                padding="0px"
                            >
                                x
                            </Button>
                        </div>
                    )}

                    {title ? <h4>{title}</h4> : null}

                    <div className="allContent">
                        {showLogo ? (
                            <div className="msg-panel">
                                <div className={logoType} />
                            </div>
                        ) : null}

                        <div className="content popupChildren">{children}</div>

                        {buttonText ? (
                            <div className="button-div">
                                <Button
                                    className="popup-button test"
                                    onPress={close}
                                    type="solid"
                                    disabled={!close}
                                    borderRadius="0px"
                                    width="180px"
                                >
                                    {buttonText}
                                </Button>
                            </div>
                        ) : null}
                    </div>
                </div>

                {showPopUp && showOverlay && (
                    <div
                        className="overlay"
                        onClick={onClickOutside}
                        onKeyPress={onClickOutside}
                        role="button"
                        tabIndex={0}
                        aria-label="overlay"
                    />
                )}
            </div>
        );
    }
}
